import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0
    }
});

export const useStyles = ({
    borders,
    colors,
    spaces
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    borders: NCoreUIKit.Borders;
}) => {
    return {
        container: {
            backgroundColor: colors.content.border.subtle,
            marginHorizontal: spaces.spacingLg / 2,
            marginVertical: spaces.spacingXs,
            height: borders.separator
        }
    };
};
export default stylesheet;
